import React from 'react'

import { Dropdown } from '../..'
import { getSortOptions } from '../../../utils'
import { useTranslation } from '../../../utils/providers'

export default function Sorter({ queryParams = {}, submitForms }) {
  const { t } = useTranslation()
  const [options, selectedOption] = getSortOptions(queryParams, t)

  return (
    <>
      <form id="product-list-sort-form" className="product-list__sorter">
        <Dropdown
          id="sorter"
          name="sorting"
          options={options}
          value={selectedOption?.value}
          onChange={submitForms}
          anchor="right"
        />
      </form>
    </>
  )
}
